
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.00052 13.1327C7.94497 13.1327 7.88663 13.1216 7.82552 13.0993C7.76441 13.0771 7.70608 13.0382 7.65052 12.9827L3.01719 8.34935C2.91719 8.24935 2.86719 8.13268 2.86719 7.99935C2.86719 7.86602 2.91719 7.74935 3.01719 7.64935C3.11719 7.54935 3.23385 7.49935 3.36719 7.49935C3.50052 7.49935 3.61719 7.54935 3.71719 7.64935L7.50052 11.4327V3.16602C7.50052 3.02157 7.54774 2.90213 7.64219 2.80768C7.73663 2.71324 7.85608 2.66602 8.00052 2.66602C8.14497 2.66602 8.26441 2.71324 8.35885 2.80768C8.4533 2.90213 8.50052 3.02157 8.50052 3.16602V11.4327L12.2839 7.64935C12.3839 7.54935 12.5005 7.49935 12.6339 7.49935C12.7672 7.49935 12.8839 7.54935 12.9839 7.64935C13.0839 7.74935 13.1339 7.86602 13.1339 7.99935C13.1339 8.13268 13.0839 8.24935 12.9839 8.34935L8.35052 12.9827C8.29497 13.0382 8.23941 13.0771 8.18385 13.0993C8.1283 13.1216 8.06719 13.1327 8.00052 13.1327Z","fill":"currentColor","stroke":"currentColor","stroke-width":"0.5"}})])
          )
        }
      }
    